
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 14.5c2.761 0 5-3.239 5-6v-1a5 5 0 00-10 0v1c0 2.761 2.239 6 5 6zM18.257 17.815c-.093-.043-.184-.088-.283-.121-1.645-.556-4.15-1.194-6.974-1.194s-5.329.638-6.974 1.193A2.99 2.99 0 002 20.532V24.5h14.349a5.97 5.97 0 01-.349-2c0-1.897.883-3.586 2.257-4.685zM23 18.5h-2v3h-3v2h3v3h2v-3h3v-2h-3v-3z","fill":"#565D6D"}})])
          )
        }
      }
    